<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="type.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Контрагенты</label>
            <crm-contragent-multi-select
              [(selectedEntities)]="type.contragents"
              [isError]="$any(errors?.contragents)"
              appendTo="body"></crm-contragent-multi-select>
            <small
              *ngIf="errors?.contragents"
              class="p-error">
              {{ errors.contragents | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Описание</label>
            <crm-input-text
              [(value)]="type.description"
              [isError]="$any(errors?.description)"></crm-input-text>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <!--          <div-->
          <!--            *ngIf="type.deleted"-->
          <!--            class="text-right">-->
          <!--            <p-tag-->
          <!--              severity="danger"-->
          <!--              value="Удален"-->
          <!--              styleClass="mt-2"></p-tag>-->
          <!--          </div>-->
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveType()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !type.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteType()"></crm-button>
        <!--        <crm-button-->
        <!--          *ngIf="(form$ | async)?.isShowDelete && type.deleted"-->
        <!--          -->
        <!--          icon="pi pi-undo"-->
        <!--          label="Восстановить"-->
        <!--          styleClass="p-button-info p-button-text"-->
        <!--          (onClick)="restoreType()"></crm-button>-->
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
